export default "__VITE_ASSET__TZJY32ue__"